var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstLoad),expression:"firstLoad"}],staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('app-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }